import(/* webpackMode: "eager", webpackExports: ["I18nEditorClient"] */ "/vercel/path0/frontend/components/Layout/I18nEditorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/Website/components/builder/BuilderPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/components/Website/components/layout/Layout.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/i18n/react/I18nProvider.tsx");
